module.exports = __webpack_public_path__ + "assets/img/floor.10086d4e.png";